import {
  AnrokProductEntitySchema,
  NetSuiteClassSchema,
  NetSuiteProductEntitySchema,
  NewMeterSchema,
  ProductIntegrationEntitySchema,
  QuickBooksProductEntitySchema,
  XeroProductEntitySchema,
} from '@vy/types';
import { oz } from '@vy/utils';

export const NewCreateProductDialogFormSchema = NewMeterSchema.pick({
  name: true,
  description: true,
  unitsType: true,
}).extend({
  cost: oz.number().optional(),
  integrationEntities: oz.array(ProductIntegrationEntitySchema).optional(),
  netSuiteProduct: NetSuiteProductEntitySchema.array().optional(),
  netSuiteClass: NetSuiteClassSchema.optional(),
  quickBooksProduct: QuickBooksProductEntitySchema.array().optional(),
  xeroProduct: XeroProductEntitySchema.array().optional(),
  anrokProduct: AnrokProductEntitySchema.array().optional(),
});

export type NewCreateProductDialogForm = oz.TypeOf<typeof NewCreateProductDialogFormSchema>;
